import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-vmi-home',
  templateUrl: './vmi-home.component.html',
  styleUrls: ['./vmi-home.component.css']
})
export class VmiHomeComponent implements OnInit {

  variable: number = 20;
  bandera: boolean = true;

  constructor() {
  }

  ngOnInit(): void {
  }

  change() {
    console.log(this.variable);
    this.bandera = false;
    setTimeout(() => {
      this.bandera = true;
    }, 100);
  }
}
